document.addEventListener('DOMContentLoaded', () => {
  const passwordVisibilityCheckBox = document.getElementById(
    'passwordVisibilityCheckBox'
  ) as HTMLInputElement;

  passwordVisibilityCheckBox.addEventListener('change', () => {
    const passwordForm = document.getElementById(
      'user_password'
    ) as HTMLInputElement;
    passwordForm.type = passwordVisibilityCheckBox.checked
      ? 'text'
      : 'password';
  });
});
